module.exports = __webpack_public_path__ + "static/scale-model-of-calypso-queen-in-clearwater-florida-778c709ae2a9775142c0f7e9ebe5f3c1.png";